import { PAYMENT_OPTIONS_KEYS } from 'constants/global';

/** Liquidación (1205), liquidación A (1219) y liquidación periodo adicional (1513). */
export const LIQUIDATION_CLAVE_PAGOS = new Set([
  PAYMENT_OPTIONS_KEYS.LIQUIDACION,
  PAYMENT_OPTIONS_KEYS.LIQUIDACION_A,
  PAYMENT_OPTIONS_KEYS.LIQUIDACION_PA,
]);

export const normalizeContractId = (contractId) => String(contractId ?? '').trim();

export const getPaymentClavePago = (payment) => (
  String(
    payment?.ClavePago
    ?? payment?.paymentKey
    ?? payment?.payment_key
    ?? '',
  )
);

export const getPaymentEmpaque = (payment) => {
  const value = payment?.Empaque
    ?? payment?.empaque
    ?? payment?.extra?.empaque
    ?? payment?.data?.empaque
    ?? payment?.data?.extra?.empaque;
  if (value == null) return '';
  return String(value).trim();
};

export const shouldShowPaymentEmpaque = (payment) => {
  const clavePago = getPaymentClavePago(payment);
  if (!LIQUIDATION_CLAVE_PAGOS.has(clavePago)) return false;
  return getPaymentEmpaque(payment).length > 0;
};

/** Campos para POST de pago/comprobante PDF (solo liquidación con Empaque válido). */
export const buildEmpaquePayloadFields = (payment) => {
  if (!shouldShowPaymentEmpaque(payment)) return {};
  return { Empaque: getPaymentEmpaque(payment) };
};

const readResponseData = (response) => response?.data ?? response;

/**
 * Lee el arreglo empaques de la respuesta Mercado Pago (single o multiple).
 * @param {object} response
 * @returns {Array}
 */
export const getPaymentEmpaques = (response) => {
  const empaques = readResponseData(response)?.empaques;
  return Array.isArray(empaques) ? empaques : [];
};

/**
 * Busca el Empaque exitoso de un contrato en la respuesta Mercado Pago.
 * @param {object} response
 * @param {string|number} contractId
 * @returns {object|null}
 */
export const findEmpaqueByContractId = (response, contractId) => {
  const targetId = normalizeContractId(contractId);
  if (!targetId) return null;

  const match = getPaymentEmpaques(response).find((item) => (
    normalizeContractId(item?.contractId) === targetId
    && item?.exitoso === true
    && String(item?.empaque ?? '').trim().length > 0
  ));

  return match ?? null;
};

/**
 * Campos de Empaque para resumen de pago único a partir de response.empaques.
 * @param {object} response
 * @param {string|number} contractId
 * @returns {{ empaque?: string }}
 */
export const getContractEmpaqueFieldsFromResponse = (response, contractId) => {
  const match = findEmpaqueByContractId(response, contractId);
  if (!match) return {};
  return { empaque: String(match.empaque).trim() };
};

/**
 * Fusiona órdenes locales con Empaque por contrato desde response.empaques.
 * @param {Array} orders
 * @param {object} response
 * @returns {Array}
 */
export const mergePaymentOrdersWithEmpaques = (orders, response) => {
  if (!Array.isArray(orders)) return [];

  return orders.map((order) => {
    const match = findEmpaqueByContractId(response, order?.contract_id);
    if (!match) return { ...order };
    return {
      ...order,
      empaque: String(match.empaque).trim(),
    };
  });
};
